/* Happy Otter — push-card off-canvas menu
 * Hijacks the existing Horizon hamburger to open this menu instead of
 * the default header-drawer.
 */
(function () {
  'use strict';

  class HappyOtterMenu {
    constructor() {
      this.html = document.documentElement;
      this.body = document.body;
      this.wrapper = document.getElementById('site-wrapper');
      this.menu = document.getElementById('ho-menu');
      this.closeBtn = document.querySelector('[data-ho-menu-close]');
      this.isOpen = false;

      if (!this.wrapper || !this.menu) return;

      // Replace the hamburger summary(s) with clones — strips ALL framework-attached listeners
      this.openBtns = [];
      document.querySelectorAll('.header__icon--menu').forEach((origBtn) => {
        const clone = origBtn.cloneNode(true);
        clone.removeAttribute('on:click');
        origBtn.parentNode.replaceChild(clone, origBtn);
        this.openBtns.push(clone);
      });

      this._bind();
      this._syncLegacyDrawer();      // initial cleanup in case framework already ran
      this._watchLegacyDrawer();     // backstop — auto-revert if framework re-adds classes
    }

    /** Force the legacy <details> drawer to a closed/clean state. */
    _syncLegacyDrawer() {
      document.querySelectorAll('header-drawer details').forEach((d) => {
        if (d.hasAttribute('open'))           d.removeAttribute('open');
        if (d.classList.contains('menu-open')) d.classList.remove('menu-open');
      });
    }

    /** MutationObserver: if anything re-adds `open` or `.menu-open` to the legacy
     *  drawer, instantly revert so the hamburger icon never sticks on X. */
    _watchLegacyDrawer() {
      if (typeof MutationObserver === 'undefined') return;
      const targets = document.querySelectorAll('header-drawer details');
      if (!targets.length) return;
      this._legacyObserver = new MutationObserver((mutations) => {
        let dirty = false;
        for (const m of mutations) {
          const el = m.target;
          if (el.hasAttribute('open') || el.classList.contains('menu-open')) {
            dirty = true;
            break;
          }
        }
        if (dirty) this._syncLegacyDrawer();
      });
      targets.forEach((d) => {
        this._legacyObserver.observe(d, {
          attributes: true,
          attributeFilter: ['class', 'open'],
        });
      });
    }

    _bind() {
      this.openBtns.forEach((btn) => {
        btn.addEventListener('click', this._onOpenClick.bind(this));
      });

      // X button (now fixed to the viewport)
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this._onCloseClick.bind(this));
      }

      // Clicking anywhere on the shrunken card closes the menu
      this.wrapper.addEventListener('click', this._onWrapperClick.bind(this));

      // Esc key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) this.close();
      });

      // If a menu link is clicked, close before navigating so transition is smooth
      this.menu.addEventListener('click', (e) => {
        const link = e.target.closest('a.ho-menu__link');
        if (!link) return;
        this.close();
      });
    }

    _onOpenClick(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      this.toggle();
    }

    _onCloseClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this.close();
    }

    _onWrapperClick(e) {
      if (!this.isOpen) return;
      if (e.target.closest('[data-ho-menu-close]')) return;
      this.close();
    }

    toggle() {
      this.isOpen ? this.close() : this.open();
    }

    open() {
      this._syncLegacyDrawer();
      // pivot the tilted page card on what's on screen, not the middle of the whole (tall) page;
      // otherwise on tablets the visible part sinks to the bottom of the screen
      var wrap = document.getElementById('site-wrapper');
      if (wrap) wrap.style.transformOrigin = 'left ' + Math.round(window.scrollY + window.innerHeight / 2) + 'px';
      this.html.classList.add('menu-open');
      this.body.classList.add('menu-open');
      this.menu.setAttribute('aria-hidden', 'false');
      this.isOpen = true;
    }

    close() {
      this.html.classList.remove('menu-open');
      this.body.classList.remove('menu-open');
      this.menu.setAttribute('aria-hidden', 'true');
      this.isOpen = false;
      // Belt-and-suspenders: also wipe the legacy drawer state when we close
      this._syncLegacyDrawer();
    }
  }

  function init() {
    new HappyOtterMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
